import React, { Component } from 'react'
import PropTypes from 'prop-types'
import IPropTypes from 'react-immutable-proptypes'

import ButtonsArea from './components/ButtonsArea'
import NameArea from './components/NameArea'

import hocConnect from './hocConnect'
import hocDialog from '../../../../../../services/dialog/hocDialog'

import './style.scss'

@hocDialog
@hocConnect
export default class Header extends Component {
    static propTypes = {
        activeGroup: IPropTypes.map.isRequired,
        deleteAllGroupMembers: PropTypes.func.isRequired,
        groupStackExportMembers: PropTypes.func.isRequired,
        groupStackState: PropTypes.object.isRequired,
        changingGroupSettings: PropTypes.bool.isRequired,
        isMonitored: PropTypes.bool.isRequired,
        members: IPropTypes.list.isRequired,
        openDialog: PropTypes.func.isRequired,
        removeGroupMonitoring: PropTypes.func.isRequired,
        toggleGroupStack: PropTypes.func.isRequired,
    }

    render() {
        const {
            activeGroup,
            toggleGroupStack,
            deleteAllGroupMembers,
            groupStackState,
            members,
            openDialog,
            removeGroupMonitoring,
            isMonitored,
            changingGroupSettings,
            groupStackExportMembers,
        } = this.props

        return (
            <div className={'group-stack-header'}>
                <NameArea toggleGroupStack={toggleGroupStack} />

                <ButtonsArea
                    groupName={activeGroup.get('name')}
                    groupId={activeGroup.get('id')}
                    toggleGroupStack={toggleGroupStack}
                    deleteAllGroupMembers={deleteAllGroupMembers}
                    groupStackState={groupStackState}
                    members={members}
                    openDialog={openDialog}
                    removeGroupMonitoring={removeGroupMonitoring}
                    isMonitored={isMonitored}
                    changingGroupSettings={changingGroupSettings}
                    groupStackExportMembers={groupStackExportMembers}
                />
            </div>
        )
    }
}
